import { useState } from 'react'

import { useTranslations } from 'next-intl'

import classnames from 'classnames'

import CloseButton from '~/components/atoms/CloseButton/CloseButton'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './SearchBar.module.css'

export interface SearchBarProps {
  testID?: string
  isFullWidth?: boolean
  placeHolderText?: string
  onChange?: (value: string) => void
}

export default function SearchBar({
  testID,
  isFullWidth = false,
  placeHolderText,
  onChange,
}: SearchBarProps) {
  const [searchValue, setSearchValue] = useState('')
  const tCommon = useTranslations('common')

  const clearSearch = () => {
    setSearchValue('')
    if (onChange) onChange('')
  }

  const handleSearchTerm = (value: string) => {
    setSearchValue(value)
    if (onChange) onChange(value)
  }

  return (
    <>
      <div className={classnames(styles.searchBase)} data-testid={testID}>
        <form autoComplete="off" action="#">
          <div className={classnames(styles.searchField)}>
            <i className={styles.searchIcon}>
              <Icon type="Magnify" width={15} height={15} />
            </i>
            <input
              type="text"
              name="q"
              className={classnames(styles.textInput)}
              value={searchValue}
              onInput={e => {
                handleSearchTerm(e.currentTarget.value)
              }}
              placeholder={placeHolderText}
            />

            {searchValue !== '' && (
              <button
                className={styles.clearBtn}
                type="button"
                onClick={e => {
                  e.stopPropagation()
                  e.preventDefault()

                  clearSearch()
                }}
              >
                <Text size={TextSizes.bodySml}>{tCommon('clear')}</Text>
              </button>
            )}

            <div className={styles.searchClose}>
              <CloseButton
                onClick={() => clearSearch()}
                background="transparent"
              />
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
